import { LicenseName } from "@/data/license.data";
import { IsDatasetLimitedResult } from "@/services/license/base/license-manager-abstractions";
import { LimiterWithUniqueLimits } from "@/services/license/license-limiters/base-limiters/limiter-with-unique-limits";

export abstract class DatasetDurationLimiter extends LimiterWithUniqueLimits {
  abstract isDatasetDurationLimited(
    userId: string,
    license: LicenseName,
    seconds: number,
  ): Promise<IsDatasetLimitedResult>;
}
